import { useState, useRef, useContext } from 'react'
import styled from '@emotion/styled'
import GoogleMapReact from 'google-map-react'
import useSupercluster from 'use-supercluster'
import { useModal } from 'react-modal-hook'
import { Box, Flex } from 'rebass'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { DataContext } from '../../contexts/dataContext'
import { getFaNum } from '../../utils/helpers'
import { mapStyles1 } from '../../styles/elements/mapStyles'
//import { filteredData } from '../../tempData/filteredData'
import ModalContainer from '../atoms/ModalContainer'
import MapToolTip from '../molecules/MapToolTip'
import ListOfRecords from '../organisms/ListOfRecords'
import PersonFetcher from '../organisms/PersonFetcher'
import FooterBar from '../atoms/FooterBar'
//import FilterDrawer from '../organisms/FilterDrawer'
import YearSelector from '../atoms/YearSelector'
import Legend from '../molecules/Legend'
import VocabFetcher from '../organisms/VocabFetcher'
import { lang } from '../../utils/lang'
import BackToTimeline from '../atoms/BackToTimeline'
import Search from '../molecules/Search'
import Count from '../molecules/Count'

//creating custom controls:
//https://developers.google.com/maps/documentation/javascript/examples/control-replacement#maps_control_replacement-javascript

const Loading = styled(Flex)`
  position: absolute;
  top: 0;
`

const MapContainer = styled(Box)`
  position: absolute;
  right: 0;
  top: 4.5rem;
  height: calc(100% - 4.5rem);
  transition: ${(props) =>
    props.isOpen
      ? 'all 0.75s ease'
      : 'all 0.25s ease'}; //adjusts slower than filterdrawer on open and faster on close
  width: 100vw;
  background-color: ${(props) => props.theme.colors.steelBlue};
  overflow: hidden;
  ${Mq.xs} {
    width: ${(props) =>
      props.intro === 'open'
        ? '100vw'
        : props.isOpen
        ? `calc(100vw - 16rem)`
        : `calc(100vw - 2rem)`};
    height: calc(100% - 6.3rem);
  }
  ${Mq.sm} {
    height: calc(100% - 4.8rem);
    top: 3rem;
  }
`
const StyledMarker = styled(Box)`
  background-color: ${(props) =>
    props.nonFatal || props.bgColor === 'orange'
      ? props.theme.colors.orange
      : props.theme.colors.red};
  border-radius: 50%;
  font-weight: 700;
  font-size: ${(props) => (props.ui === 'en' ? '.7rem' : '1.2rem')};
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.44);
`
const Marker = ({ children, $hover }) => {
  return children($hover)
}
const isSmall = window.innerWidth < 500

function createMapOptions(maps) {
  return {
    zoomControl: !isSmall,
    zoomControlOptions: {
      position: maps.ControlPosition.TOP_LEFT,
      style: maps.ZoomControlStyle.SMALL
    },
    //   mapTypeControlOptions: {
    //     position: maps.ControlPosition.TOP_RIGHT
    //   },
    fullscreenControl: false,
    clickableIcons: false,
    //mapId: '2ec25056b8c8bb3f'
    styles: mapStyles1
    //disableDefaultUI: true //if want to create custom controls
  }
}
const Map = () => {
  const {
    formattedData,
    formattedNonFatalData,
    intro,
    ui,
    selections,
    loading,
    nonFatalLoading,
    query,
    nonFatalQuery
    //names
  } = useContext(DataContext)
  const [selectedYear, setSelectedYear] = useState(['All Years'])
  //const [filteredData, setFilteredData] = useState()

  //temp data munching to get coordinates
  // const matchIds = (filteredData, formattedData) => {
  //   formattedData.map((d) => {
  //     const match = filteredData.find(
  //       (f) => f.viol_full_placename === d.location
  //     )
  //     const coordinates = match?.coordinates.split(',')
  //     if (coordinates) {
  //       d.lat = +coordinates[0]
  //       d.lng = +coordinates[1]
  //     }
  //     return d
  //   })
  // }
  // if (formattedData) matchIds(filteredData, formattedData)

  const arrestFilter = (d) =>
    (selections['Arrests'] === 'Arrests not made' && !d.arrested) ||
    (selections['Arrests'] === 'Arrests made' && d.arrested) ||
    selections['Arrests'] === 'ALL'

  const prosecutionFilter = (d) =>
    (selections['Prosecution'] === 'Prosecutions not attempted' &&
      !d.prosecuted) ||
    (selections['Prosecution'] === 'Prosecutions attempted' && d.prosecuted) ||
    selections['Prosecution'] === 'ALL'

  //old filtering
  // const dataWithCoordinates = formattedData
  //   ? //add filtering for arrests and prosecutions here?
  //     formattedData.filter((d) => d.coordinates)
  //   : []

  // if (dataWithCoordinates && selectedYear !== 'All Years') {
  //   //filter years
  //   var filteredData = dataWithCoordinates.filter(
  //     (d) => d.year === selectedYear
  //   )
  // }

  if (formattedData && formattedNonFatalData) {
    var allData =
      query && nonFatalQuery
        ? formattedData?.concat(formattedNonFatalData)
        : query
        ? formattedData
        : nonFatalQuery
        ? formattedNonFatalData
        : null
  }
  //refactor
  const filteredData = allData
    ? allData.filter((d) => {
        return d.coordinates && arrestFilter(d) && prosecutionFilter(d)
          ? selectedYear[0] !== 'All Years'
            ? selectedYear.includes(d.year)
            : d
          : null
      })
    : []

  const numNonFatal = filteredData
    .map((d) => (d.nonFatal ? d : null))
    .filter((item) => item).length
  const numFatal = filteredData.length - numNonFatal

  const mapRef = useRef()
  const [zoom, setZoom] = useState(5)
  const [bounds, setBounds] = useState(null)

  //const points = (filteredData ? filteredData : dataWithCoordinates).map(
  const points = filteredData.map((d) => ({
    type: 'Feature',
    properties: {
      cluster: false,
      id: d.id,
      fnames: d.fnames,
      sname: d.sname,
      age: d.age,
      location: d.location,
      //month: d.month,
      //day: d.day,
      date: d.date,
      //year: d.year,
      photoUrlSm: d.photoUrlSm,
      photoUrlLg: d.photoUrlLg,
      nonFatal: d.nonFatal ? true : false
    },
    geometry: {
      type: 'Point',
      coordinates: [+d.coordinates.long, +d.coordinates.lat]
    }
  }))

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 20 }
  })

  const [clusterId, setClusterId] = useState(null)
  const [personId, setPersonId] = useState(null)
  const [nonFatalCase, setNonFatalCase] = useState(null)

  const [showListModal, hideListModal] = useModal(
    () => (
      <ModalContainer
        hideModal={hideListModal}
        personId={personId}
        setPersonId={setPersonId}
        list={true}
        nonFatalCase={nonFatalCase}
        handleNonFatalCase={(nonFatal) => setNonFatalCase(nonFatal)}
      >
        <ListOfRecords
          records={supercluster.getLeaves(clusterId, Infinity)}
          handleId={(id) => setPersonId(id)}
          personId={personId}
          handleNonFatalCase={(nonFatal) => setNonFatalCase(nonFatal)}
          nonFatalCase={nonFatalCase}
        />
      </ModalContainer>
    ),
    [supercluster, clusterId, personId, setPersonId]
  )

  const [showPersonModal, hidePersonModal] = useModal(
    () => (
      <ModalContainer
        hideModal={hidePersonModal}
        personId={personId}
        setPersonId={setPersonId}
        nonFatalCase={nonFatalCase}
        handleNonFatalCase={(nonFatal) => setNonFatalCase(nonFatal)}
      >
        <PersonFetcher
          personId={personId}
          nonFatalCase={nonFatalCase}
          handleNonFatalCase={(nonFatal) => setNonFatalCase(nonFatal)}
        />
      </ModalContainer>
    ),
    [personId, nonFatalCase]
  )

  const [isOpen, setIsOpen] = useState(false)

  const handleDrawer = () => {
    setIsOpen(!isOpen)
  }

  const mapConfig = {
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    language: ui
  }
  const baseSize = 15

  return (
    <>
      {/* <FilterDrawer
        handleDrawer={handleDrawer}
        isOpen={isOpen}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
      /> */}
      {/* {intro === 'closed' && ( */}
      <VocabFetcher
        handleDrawer={handleDrawer}
        isOpen={isOpen}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
      />
      {/* )} */}

      <MapContainer isOpen={isOpen} intro={intro}>
        <GoogleMapReact
          bootstrapURLKeys={mapConfig}
          defaultCenter={{ lat: 42, lng: 36 }}
          defaultZoom={3}
          options={createMapOptions}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => {
            mapRef.current = map
          }}
          onChange={({ zoom, bounds }) => {
            setZoom(zoom)
            setBounds([
              bounds.nw.lng,
              bounds.se.lat,
              bounds.se.lng,
              bounds.nw.lat
            ])
          }}
        >
          {clusters.map((cluster) => {
            const [longitude, latitude] = cluster.geometry.coordinates

            const { cluster: isCluster, point_count: pointCount } =
              cluster.properties
            let clusterColor
            if (isCluster) {
              const group = supercluster.getLeaves(cluster.id, Infinity)
              //get cluster color. If it has any fatal cases, make it red.
              for (const d of group) {
                if (!d.properties.nonFatal) {
                  clusterColor = 'red'
                  break
                } else clusterColor = 'orange'
              }
              return (
                <Marker key={cluster.id} lat={latitude} lng={longitude}>
                  {($hover) => (
                    <StyledMarker
                      ui={ui}
                      width={baseSize + (pointCount / points.length) * 100}
                      height={baseSize + (pointCount / points.length) * 100}
                      onClick={() => {
                        setClusterId(cluster.id)
                        showListModal()
                      }}
                      bgColor={clusterColor}
                      // const expansionZoom = Math.min(
                      //   supercluster.getClusterExpansionZoom(cluster.id),
                      //   10
                      // )
                      // mapRef.current.setZoom(expansionZoom)
                      // mapRef.current.panTo({ lat: latitude, lng: longitude })
                      //}}
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="center"
                        height="100%"
                        pt={ui === 'en' ? '.1rem' : '.4rem'}
                      >
                        {ui === 'en' ? pointCount : getFaNum(pointCount)}
                      </Flex>
                      <MapToolTip
                        isCluster={true}
                        show={$hover}
                        numKillings={pointCount}
                        widthOfCluster={10 + (pointCount / points.length) * 50}
                      />
                    </StyledMarker>
                  )}
                </Marker>
              )
            }
            return (
              <Marker
                key={cluster.properties.id}
                lat={latitude}
                lng={longitude}
              >
                {($hover) => {
                  const {
                    fnames,
                    sname,
                    age,
                    location,
                    //month,
                    //year,
                    date,
                    id,
                    photoUrlSm,
                    nonFatal
                  } = cluster.properties
                  return (
                    <StyledMarker
                      width={baseSize}
                      height={baseSize}
                      onClick={() => {
                        setPersonId(id)
                        setNonFatalCase(nonFatal) //sets state of whether this is a threat case or not. This tells modal whether to render footer bar or not.
                        showPersonModal()
                      }}
                      nonFatal={nonFatal}
                    >
                      <MapToolTip
                        d={{
                          fnames,
                          sname,
                          age,
                          location,
                          //month,
                          //year,
                          date,
                          photoUrlSm,
                          nonFatal
                        }}
                        show={$hover}
                      ></MapToolTip>
                    </StyledMarker>
                  )
                }}
              </Marker>
            )
          })}
        </GoogleMapReact>
        {intro === 'closed' && (loading || nonFatalLoading) && (
          <Loading
            width="100%"
            height="10%"
            alignItems="center"
            justifyContent="center"
          >
            {lang[ui]['Loading']}
          </Loading>
        )}
        <Search handlePersonId={setPersonId} handleModal={showPersonModal} />
        <Count fatalNum={numFatal} nonFatalNum={numNonFatal} />
        <BackToTimeline isOpen={isOpen} intro={intro} />
        <Legend />
        <YearSelector
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
        />
      </MapContainer>

      <FooterBar map={true} />
    </>
  )
}
export default Map
